import { CommonModule } from "@angular/common";
import { Component, HostListener } from "@angular/core";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";

@Component({
  selector: "app-footer",
  standalone: true,
  imports: [CommonModule, PrimeNGSharedModule],
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.scss",
})
export class FooterComponent {
  expanded = false;
  lastUpdated = "April 2026";
  currentYear = new Date().getFullYear();

  toggleFooter() {
    this.expanded = !this.expanded;
    if (this.expanded) {
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }, 0);
    }
  }

  lastScrollTop = 0;

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const currentScroll = window.scrollY;

    if (currentScroll < this.lastScrollTop && this.expanded) {
      this.expanded = false;
    }

    this.lastScrollTop = currentScroll;
  }
}
